import React from 'react'
import { Container } from 'react-bootstrap'
import './Header.css'
import PlaceIcon from '@mui/icons-material/Place';
import EmailIcon from '@mui/icons-material/Email';

const TopHeader = () => {
  return (
    <div className=" text-center bg-primary-300 text-slate-500 font-semibold">
            <Container className='px-2'> 
                <div className='flex items-center justify-between py-1 text-xs'>
                  <div className="flex  py-1">
                    <div className=""><PlaceIcon  style={{fontSize: 'medium'}}/></div>
                    <p className="ml-1 ">Oraifite, Anambra State</p>
                  </div>
                  <div className="flex  py-1">
                    <div className=""><EmailIcon style={{fontSize: 'medium'}} /></div>
                    <p className="ml-1">info@oyoyolubricant.com</p>
                  </div>
                </div>
                
            </Container>
        </div>
  )
}

export default TopHeader
